export enum LOYALTY_ENUMS {
  APPLY = 'apply',
  REMOVE = 'remove',
  LOYALTY_APPLIED_ON_ORDER = 'loyalty_applied_on_order'
}
